import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';

interface IProps { customerId: string; }

export const useGetIndustries = (
  { customerId }: IProps,
  onError: (error: any) => void,
) => useQuery(
  'getIndustryList',
  async () => {
    const { data } = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/industryList`);
    return data.industryList;
  },
  {
    onError: (error: IServerErrorResponse) => {
      onError(flattenServerErrorResponse(error));
    },
    refetchOnWindowFocus: false,
  },
);
